import { S_BREAKPOINT } from './useWindowResize';

/**
 * Determines if the current window is narrow (side panel) or wide (full screen)
 * @returns true if window width is less than or equal to the small breakpoint
 */
export const isNarrowWindow = (): boolean => window.innerWidth <= S_BREAKPOINT;
